
export const ReportsAuditLabelName = {
    'audit-report': "Audit Report",
} as const;


export enum ReportsAuditPermissions {
    'audit-report' = "Audit Report",
}